<div class="poa-pdf-options">
    <div class="form-check mb-2">
        <input class="form-check-input" type="radio" name="poaPdfMode" id="poaPdfAll"
            [(ngModel)]="selectedMode" value="all">
        <label class="form-check-label" for="poaPdfAll">
            All test areas in one PDF
        </label>
    </div>

    <div class="form-check mb-2">
        <input class="form-check-input" type="radio" name="poaPdfMode" id="poaPdfSelected"
            [(ngModel)]="selectedMode" value="selected">
        <label class="form-check-label" for="poaPdfSelected">
            Selected test areas
        </label>
    </div>

    <div class="poa-pdf-options__portions ml-4 mt-2" *ngIf="selectedMode === 'selected'">
        <div class="form-check mb-2" *ngFor="let portion of acsTestPortions">
            <input class="form-check-input" type="checkbox" [id]="'poaPdfPortion' + portion.AcsTestPortionId"
                [(ngModel)]="selectedAcsTestPortionIds[portion.AcsTestPortionId]">
            <label class="form-check-label" [for]="'poaPdfPortion' + portion.AcsTestPortionId">
                {{portion.AcsTestPortion}}
            </label>
        </div>

        <div class="text-danger small mt-2" *ngIf="!hasSelectedPortions()">
            Select at least one test area.
        </div>
    </div>

    <div class="text-muted small mt-3">
        The PDF will download when generation is complete.
    </div>
</div>
